import { ScrapbookFile } from '@/api/scrapbook-data';
import ContentPreviewWraper from './ContentPreviewWraper';
import Quote from '@/components/quote/Quote';
import Quotee from '@/components/quote/Quotee';
import classNames from 'classnames';
import { isColorDark } from '@/utils';

interface QuotePreviewProps {
  content: ScrapbookFile | null;
  onClose: () => void;
}
const QuotePreview = ({ content, onClose }: QuotePreviewProps) => {
  if (!content) return null;

  const onCopy = async () => {
    if (!content) return;

    const formattedHtmlContent = `<html><p>${content.content.preTitle}</p><p>${content.content.quote}</p><p>${content.content.expert?.expertName || ''}</p><p>${content.content.expert?.jobTitle || ''}</p></html>`;
    const formattedContent = `${content.content.preTitle}\t\n${content.content.quote}\t\n${content.content.expert?.expertName || ''}\t\n${content.content.expert?.jobTitle || ''}\n\n`;

    if (navigator.clipboard && navigator.clipboard.write) {
      await navigator.clipboard.write([
        new ClipboardItem({
          'text/html': new Blob([formattedHtmlContent], { type: 'text/html' }),
          'text/plain': new Blob([formattedContent], { type: 'text/plain' }),
        }),
      ]);
    }
  };

  return (
    <ContentPreviewWraper
      content={content}
      onClose={onClose}
      title="Quote"
      subTitle={content?.content?.pageTitle}
      onCopy={onCopy}
    >
      <div
        className={classNames(
          'quote-preview-content my-4 max-w-[60vw] px-5 py-5',
          isColorDark(content.content.backgroundColor) ? 'module-base-light' : 'module-base-dark',
        )}
        style={{
          backgroundColor: content.content.backgroundColor,
        }}
      >
        <Quote
          quote={{
            moduleName: 'QuoteModule',
            preTitle: content.content.preTitle || '',
            quote: content.content.quote || '',
            expert: content.content.expert,
          }}
          hideButtons
          backgroundColor={content.content.backgroundColor}
        />
        <Quotee expert={content.content.expert} />
      </div>
    </ContentPreviewWraper>
  );
};

export default QuotePreview;
